import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import { InstagramFeed } from 'components/instagram-feed/InstagramFeed';
import DashboardComponentHeader from './common/DashboardComponentHeader';
import DashboardComponentLink from './common/DashboardComponentLink';

export const DashboardInstagramFeed = ({ loading }: { loading?: boolean }) => {
  if (loading) {
    return null;
  }

  return (
    <InstagramFeed
      wrapper={(children) => (
        <AboutUsModule background={'grey'}>
          <AboutUsSiteContainer overlapBelow>
            <AboutUsSiteInnerContainer
              background="white"
              borderRadius
              withPadding
            >
              <DashboardComponentHeader
                title="#DAYMADE"
                subtitle={
                  <>
                    Discover the latest <strong>DAYMADE</strong> Instagram
                    highlights, with giveaways, prizes, and more
                  </>
                }
                separator
              />
              {children}
              <DashboardComponentLink
                href="https://www.instagram.com/daymadeuk/"
                linkText="View on Instagram"
                target="_blank"
                rel="noopener noreferrer"
              />
            </AboutUsSiteInnerContainer>
          </AboutUsSiteContainer>
        </AboutUsModule>
      )}
    />
  );
};
